import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Dispatch, Fragment, ReactNode, SetStateAction, useState } from 'react';
//
interface ModalProps {
  children: ReactNode;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  closeButton?: boolean;
  panelClassName?: string;
  padding?: string;
}

export default function Modal({
  children,
  open,
  setOpen,
  closeButton = true,
  panelClassName = 'bg-out-dark-gray',
  padding = 'px-4 pb-4 pt-5 sm:p-6 sm:my-8',
}: ModalProps) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as='div' className='relative z-[60]' onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black-filled-default bg-opacity-75 transition-opacity' />
        </Transition.Child>
        <div className='fixed inset-0 z-10 w-screen overflow-y-auto'>
          <div className='flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <Dialog.Panel
                className={`relative w-full overflow-y-clip overflow-x-hidden rounded-xl ${panelClassName} ${padding} text-left text-white-filled-default shadow-xl transition-all sm:w-full sm:max-w-md`}
              >
                {closeButton && (
                  <XMarkIcon
                    className='absolute right-3 top-3 h-6 w-6 text-white-filled-default'
                    onClick={() => setOpen(false)}
                  />
                )}
                <div>{children}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
